import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const featureList = [
	{
		icon: 'https://web-data.zmlearn.com/image/6CRYK5PEp3T1AUkjvyGfVc/bottom_1%402x.png',
		title: 'Free trial session',
		desc: 'Totally free for the first time.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/8YqFzs5jAtzNwPd9dFxs8s/bottom_2%402x.png',
		title: 'Replacement tutor',
		desc: 'A suitable replacement will be found in the shortest possible time for free.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/jceFLtuhrpaJedWQ635gi5/bottom_3%402x.png',
		title: 'Hassle-free refund',
		desc: 'Free refund within 14 days if you are disatisfied with the lessons.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/sbbsgCVtgcXSWuBv6CEVgE/bottom_4%402x.png',
		title: 'Anytime money back',
		desc: 'The remaining tuition fee can be refunded unconditionally at any time after 3 classes.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/45RcfiPhcaNczvCXN1dagX/bottom_5%402x.png',
		title: 'Security ',
		desc: 'All common payment methods are available and all data and personal information is 100% secure with us.',
	},
];
/**
 * Feature模块
 * @returns
 */
export default function FeatureBlock() {
	return (
		<div className={cx('feature-box')}>
			<Section>
				<div className={cx('feature-list')}>
					{featureList.map((item) => {
						return (
							<div key={item.title} className={cx('feature-item')}>
								<img src={item.icon} alt="" loading='lazy' />
								<dl>
									<dt>{item.title}</dt>
									<dd>{item.desc}</dd>
								</dl>
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
